
document.addEventListener('DOMContentLoaded', function () {
  const cta = document.getElementById('bsStickyCTA');
  if (!cta) return;

  let lastScroll = window.scrollY;
  let lastShown = Date.now();
  let isHidden = false;

  const showCTA = () => {
    cta.classList.remove('hidden');
    lastShown = Date.now();
    isHidden = false;
  };

  const hideCTA = () => {
    cta.classList.add('hidden');
    isHidden = true;
  };

  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;

    if (currentScroll > lastScroll && currentScroll > 100) {
      // scroll down
      if (!isHidden) hideCTA();
    } else {
      // scroll up
      if (isHidden) showCTA();
    }

    lastScroll = currentScroll;
  });

  // Optional: re-show after inactivity
  setInterval(() => {
    if (isHidden && Date.now() - lastShown > 8000) {
      showCTA();
    }
  }, 2000);
});
